import React from 'react'

import { Input as ChakraInput } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'
import FieldWrapper from '../FieldWrapper'

const Input = ({
  name,
  type = 'text',
  disabled,
  placeholder = 'Enter',
  isRequired = true,
  canHighLight = true,
  autoComplete = 'new-password',
  extraOnChange = () => {},
  ...rest
}) => {
  return (
    <Controller
      name={name}
      // rules={{
      //   required: isRequired ? 'Required' : false,
      // }}
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => {
        return (
          <FieldWrapper name={name} error={error} tooltip={value} isRequired={isRequired} {...rest}>
            <ChakraInput
              // color="blackAlpha.600"
              // bg={(value === undefined || value === '') && isRequired && canHighLight ? 'yellow' : 'primary'}
              ref={ref}
              value={value !== undefined ? value : ''}
              onChange={(e) => {
                onChange(type === 'number' ? +e.target.value : e.target.value)
                extraOnChange(type === 'number' ? +e.target.value : e.target.value)
              }}
              onBlur={onBlur}
              onFocus={() => {
                let errorElement = document.getElementById(name)
                if (errorElement) {
                  errorElement.scrollIntoView({ behavior: `smooth`, block: 'center' })
                }
              }}
              type={type}
              placeholder={placeholder || 'Enter'}
              disabled={disabled}
              autoComplete={autoComplete}
              // ariaAutocomplete="none"
            />
          </FieldWrapper>
        )
      }}
    />
  )
}

export default Input
